@switch (type) {
    @case (snackBarType.Success) {
        <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
    }
    @case (snackBarType.Error) {
        <mat-icon class="material-symbols-outlined">error</mat-icon>
    }
    @default {
        <mat-icon class="material-symbols-outlined">warning</mat-icon>
    }
}
<span class="ms-1">{{ text | translate }}</span>
